module.exports = __webpack_public_path__ + "img/Large-Bevel-Attachment-34.1a0d330f.png";